export default "images/目的地、距离和预计到达时间.png";